// extracted by mini-css-extract-plugin
export default {"root":"textbox_root__B7EkH","icon":"textbox_icon__Ak2dx","input":"textbox_input__YEcoa","clear":"textbox_clear__RXiHd","upload-icon":"textbox_upload-icon__6aiwQ"};